varying vec3 vPos;
uniform float uTime;
uniform float uScroll;

void main()
{
  float distanceToCenter = distance(gl_PointCoord, vec2(0.5));
  float strength = 1.0 - smoothstep(0.0, 0.5, distanceToCenter);
  strength = pow(strength, 2.0);
  float opacity = 0.0;

  if (uScroll < uRange) {
    opacity = 0.0;
  } else if (uScroll < uRange * 2.0) {
    opacity = 0.0;
  } else if (uScroll < uRange * 3.0) {
    opacity = mix(0.0, 1.0, (uScroll - uRange * 2.0) * uTotalModels );
  } else {
    opacity = mix(1.0, 0.0, (uScroll - uRange * 3.0) * uTotalModels );
  }

  vec3 horseColor = vec3(0.95, 0.85, 0.70); // Refined Champagne Gold
  gl_FragColor = vec4(horseColor, strength * opacity * 0.85);
}
